import { Listener } from '../listenersStore';

const realtimeUpdatesListeners: Listener = {
  realtimeUpdate: (dispatch: any, action: any) => {
    dispatch({
      type: 'REALTIME_UPDATES_RECIEVED',
      payload: action.payload,
    });
  },
};

export default realtimeUpdatesListeners;
